import { Link } from "react-router-dom";
import { CalendarDays, ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import Seo from "@/components/Seo";
import { useContent } from "@/context/ContentContext";

export default function BookCall() {
  const { booking: b = {} } = useContent();
  let src = b.url || "";
  if (src.includes("calendar.google.com") && !src.includes("gv=true")) {
    src += (src.includes("?") ? "&" : "?") + "gv=true";
  }

  return (
    <div className="pt-20">
      <Seo
        title="Book a Call | Kim Kornachuk"
        description="Grab time directly on Kim Kornachuk's calendar for intro chats, hiring conversations, and GTM or marketing consults."
        path="/book"
      />
      <section className="relative overflow-hidden">
        <div className="absolute inset-y-0 left-0 w-1/2 orange-wash opacity-50 pointer-events-none" />
        <div className="max-w-7xl mx-auto px-6 sm:px-10 pt-16 sm:pt-24 pb-12 relative">
          <Reveal>
            <p className="font-mono-brand text-xs uppercase tracking-[0.25em] text-[var(--brand-primary)] mb-6 t-heading">{b.kicker}</p>
            <h1 className="font-display text-6xl sm:text-8xl leading-[0.92] tracking-tight max-w-4xl whitespace-pre-line t-heading">{b.heading}</h1>
            <p className="mt-6 text-lg text-[var(--brand-muted)] font-medium max-w-2xl t-body">{b.description}</p>
          </Reveal>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 sm:px-10 pb-24">
        {src ? (
          <Reveal>
            <div className="bg-[#FBF9F4] border border-[#E7DFD0] rounded-3xl shadow-[0_8px_30px_-14px_rgba(28,24,21,0.16)] p-2 sm:p-4">
              <iframe
                src={src}
                title="Book a call with Kim Kornachuk"
                data-testid="booking-embed"
                className="w-full rounded-2xl"
                style={{ height: "900px", border: 0 }}
              />
            </div>
          </Reveal>
        ) : (
          <Reveal>
            <div className="bg-[#FBF9F4] border border-[#E7DFD0] rounded-3xl shadow-[0_8px_30px_-14px_rgba(28,24,21,0.16)] p-10 sm:p-14 text-center" data-testid="booking-unavailable">
              <CalendarDays size={44} className="text-[var(--brand-primary)] mx-auto" />
              <h2 className="font-display text-3xl sm:text-4xl tracking-tight mt-5">Online booking opens soon.</h2>
              <p className="mt-4 text-[var(--brand-muted)] font-medium max-w-xl mx-auto">In the meantime, send me a message and I'll get back to you with times.</p>
              <Link to="/contact" data-testid="booking-contact-cta" className="group mt-8 inline-flex items-center gap-2 bg-[var(--brand-primary)] text-[var(--brand-cream)] px-7 py-4 rounded-full font-bold uppercase tracking-[0.1em] text-sm transition-all hover:bg-[var(--brand-primary-dark)] shadow-[0_10px_30px_-10px_rgba(225,37,27,0.6)]">
                Contact me <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </Reveal>
        )}
      </section>
    </div>
  );
}
